export enum DashboardNotificationsEnum {
  BROKER_INFO_INCOMPLETE = 'BROKER_INFO_INCOMPLETE',
  UPGRADE_SUBSCRIPTION = 'UPGRADE_SUBSCRIPTION',
  CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION',
  PHONE_VERIFICATION = 'PHONE_VERIFICATION',
  BROKER_LICENSE = 'BROKER_LICENSE',
  TRIAL_EXPIRED = 'TRIAL_EXPIRED',
}
